import React, { useEffect, useState, useRef } from "react";
import StyleWrapper from "./style";
import { useTranslation } from "react-i18next";
import { Toast } from "primereact/toast";
import { Accordion, AccordionTab } from "primereact/accordion";
import { Checkbox } from "primereact/checkbox";

import { ReactComponent as UPArrow } from "assets/images/lead/arrow-up-circle-white.svg";
import { ReactComponent as DownArrow } from "assets/images/lead/arrow-down-circle-white.svg";
import { ReactComponent as CarIco } from "assets/images/lead/motor-insurance.svg";
import { ReactComponent as CalenderIco } from "assets/images/lead/calendar.svg";
import { ReactComponent as PlateIco } from "assets/images/lead/motor-Number plate.svg";
import { ReactComponent as SARIco } from "assets/images/lead/claim-saudi.svg";
import { ReactComponent as MaleIco } from "assets/images/lead/gender-male.svg";
import { ReactComponent as FemaleIco } from "assets/images/lead/gender-female.svg";
import { ReactComponent as AddIco } from "assets/images/lead/add-01.svg";
import { ReactComponent as TrashIco } from "assets/images/lead/trash.svg";
import config from "application/motor/helpers/config";

import {
  ConvertToArabicNumbers,
  ConvertToEnglishLetters,
} from "helpers/plate-number-converter.util";
import {
  getFormErrorMessage,
  getGregYearOfBirthList,
  getHijriYearOfBirthList,
  getOneLetterLanguageCode,
  isArabic,
  isFormFieldValid,
  isSaudi,
  isValidSaudiIDOrIQama,
  numberWithCommas,
} from "helpers/utils";
import { getDefaultValues, getDriverDetailsPolicy } from "services/motorRetailService";
import {
  removeDriver,
  updateLocalDriver,
  updateLocalVehicleDetails,
} from "redux/actions/motorActions";
import { useDispatch, useSelector } from "react-redux";
import e from "react-date-object/calendars/arabic";
import { getModelsByMakeCode } from "services/motorRetailService";
import { Dropdown } from "primereact/dropdown";
import { useFormik } from "formik";
import { updateLoading } from "redux/actions/commonActions";
import { classNames } from "primereact/utils";
import { InputText } from "primereact/inputtext";
import { Divider } from "primereact/divider";
import { Button } from "primereact/button";
import LeadInput from "../Input.js/Input";
import { InputNumber } from "primereact/inputnumber";

const VehicleCard = ({ vehicle, triggerGetProposal, onCheckboxChange, formik, setValidToGo }) => {
  const { customerDetails, drivers } = useSelector((state) => state.motor);
  const dispatch = useDispatch();
  const [t, i18n] = useTranslation();
  const [models, setModels] = useState([]);
  const [yearOfBirthList, setYearOfBirthList] = useState(getGregYearOfBirthList());
  const [defaultValues, setDefaultValues] = useState();
  const [makes, setMakes] = useState([]);
  const [colorlist, setColorlist] = useState([]);
  const [selectedItems, setSelectedItems] = useState(formik.values.vehicleList);
  const [accordion, toggleAccordion] = useState(true);
  const toast = useRef(null);
  const businessLine = "elm";
  const [showAddDriver, setShowAddDriver] = useState(false);
  const repairTypeList = [
    { nameEn: "Workshop", nameAr: "الورش", value: "N" },
    { nameEn: "Agency", nameAr: "وكالة", value: "Y" },
  ];
  const handleAccordion = (bool) => {
    toggleAccordion(bool);
  };

// ----------------------------------------------------------------------------
// Vehicle Information
  const vehicleFormik = useFormik({
    initialValues: {
      model: null,
      vehicleValue: vehicle?.vehicleValue,
      deductible: vehicle?.deductible,
      repairType: vehicle.agencyRepairRequired,
      deductibleSP: vehicle.deductibleSP,
    },
    validate: (data) => {
      let errors = {};


      if (!data.model) {
        errors.model =
          i18n.language == "en" ? "model is required." : "موديل السيارة مطلوب";
      }

      if (!data.vehicleValue) {
        errors.vehicleValue =
          i18n.language == "en" ? "Vehicle value is required." : "قيمة السيارة مطلوبة";
      } else if (
        +data?.vehicleValue < +defaultValues?.vehicleValue?.min ||
        +data?.vehicleValue > +defaultValues?.vehicleValue?.max
      ) {
        errors.vehicleValue =
          i18n.language == "en"
            ? `Vehicle value must be between ${+defaultValues?.vehicleValue?.min}-${+defaultValues?.vehicleValue?.max}`
            : `يجب أن تتراوح قيمة السيارة بين ${+defaultValues?.vehicleValue?.min}-${+defaultValues?.vehicleValue?.max} `;
      }
      else if(!/^[0-9]+$/.test(data.vehicleValue)){
        errors.vehicleValue = i18n.language == "en" ? "Accept ONLY numbers." : "يقبل أرقام فقط ";
      }

      if (!data.deductible) {
        errors.deductible =
          i18n.language == "en"
            ? "Deductible value is required."
            : "نسبة التحمل مطلوبة";
      }

      if (!data.deductibleSP) {
        errors.deductibleSP =
          i18n.language == "en"
            ? "Deductible value is required."
            : "نسبة التحمل مطلوبة";
      }
      return errors;
    },
    onSubmit: (data) => {

    },
  });
// ----------------------------------------------------------------------------


// ----------------------------------------------------------------------------
// Vehicle selection
  const handleCheckboxChange = (value) => {
    const updatedSelection = [...selectedItems];
    if (updatedSelection.includes(value)) {
      // Remove item if already selected
      updatedSelection.splice(updatedSelection.indexOf(value), 1);
    } else {
      // Add item if not selected
      updatedSelection.push(value);
    }
    setSelectedItems(updatedSelection);
    // onCheckboxChange(updatedSelection); // Pass selected values to parent
  };

  useEffect(() => {
    formik.setFieldValue("vehicleList", selectedItems);
  }, [selectedItems]);

  useEffect(() => {
    setSelectedItems(formik.values.vehicleList);
  }, [formik.values.vehicleList]);

// ----------------------------------------------------------------------------
//load defalt values
  useEffect(() => {
    vehicleFormik.submitForm();
    getDefaultValuesCall();
    getModelsByMakeCode(vehicle?.makeCode, businessLine).then(({ data }) => {
      const { modelDetailsArray } = data;
      const modelListRemapped = modelDetailsArray?.map((model) => ({
        id: model.modelCode,
        name: model.name,
        ...model,
      }));
      setModels(modelListRemapped);
      const model = modelListRemapped.find(model => model.id === vehicle?.modelCode);
      vehicleFormik.setFieldValue('model',model);

    });
  }, []);
  
  const getDefaultValuesCall = async () => {
    const request = {
      productCode: "ALL",
      yearOfManufacture: vehicle?.yearOfManufacture,
      modelCode: vehicle?.modelCode || vehicleFormik.values.model.modelCode,
      makeCode: vehicle?.makeCode,
      chassisNumber: vehicle.chassisNumber,
      languageCode: getOneLetterLanguageCode(i18n.language),
    };
  
    try {
      const res = await getDefaultValues(request, businessLine);
      const result = res.data;
      setDefaultValues(result);
      if (result?.resultCode === "S") {
        const myVehicle = {
          ...vehicle,
          vehicleValue: result.vehicleValue?.avg,
          modelCode: vehicle?.modelCode || vehicleFormik.values.model?.modelCode,
          modelName: vehicle?.modelName || vehicleFormik.values.model?.description,
          deductible: result.deductible
        };
        dispatch(updateLocalVehicleDetails(myVehicle));
        vehicleFormik.setFieldValue('vehicleValue', result.vehicleValue?.avg);
        vehicleFormik.setFieldValue('deductible', result.deductible);
        vehicleFormik.setFieldValue('deductibleSP', result?.spDeductibleList[0]?.deductible);
          
        const updatedSelection = [...formik.values.vehicleList];
        if (updatedSelection.length) {
          return
        } else {
          updatedSelection.push(vehicle.chassisNumber);
          formik.setFieldValue("vehicleList", updatedSelection);
        }       
      }
    } catch (error) {
      // getDefaultValuesCall();
    }
  };

  useEffect(() => {
    //triggerGetProposal();
    vehicleFormik.submitForm();
  }, [defaultValues]);
// ----------------------------------------------------------------------------
// update Vehicle Values
  useEffect(() => {
    if (vehicleFormik.values.model) {
      const myVehicle = {
        ...vehicle,
        modelCode: vehicleFormik.values.model.modelCode,
        modelName: vehicleFormik.values.model.description,
      };
      dispatch(updateLocalVehicleDetails(myVehicle));
      getDefaultValuesCall();
    }
  }, [vehicleFormik.values.model]);

  useEffect(() => {
    if (vehicleFormik.values.deductible) {
      const myVehicle = {
        ...vehicle,
        deductible: vehicleFormik.values.deductible,
      };
      dispatch(updateLocalVehicleDetails(myVehicle));
    }
  }, [vehicleFormik.values.deductible]);


  useEffect(() => {
    if (vehicleFormik.values.deductibleSP) {
      const myVehicle = {
        ...vehicle,
        deductibleSP: vehicleFormik.values.deductibleSP,
      };
      dispatch(updateLocalVehicleDetails(myVehicle));
    }
  }, [vehicleFormik.values.deductibleSP]);  

  useEffect(() => {
    if (
      vehicleFormik.values.vehicleValue &&
      +vehicleFormik.values.vehicleValue > +defaultValues?.vehicleValue?.min &&
      +vehicleFormik.values.vehicleValue < +defaultValues?.vehicleValue?.max
    ) {
      const myVehicle = {
        ...vehicle,
        vehicleValue: vehicleFormik.values.vehicleValue,
      };
      dispatch(updateLocalVehicleDetails(myVehicle));

    }
  }, [vehicleFormik.values.vehicleValue]);

  useEffect(() => {
    if (vehicleFormik.values.repairType) {
      const myVehicle = {
        ...vehicle,
        agencyRepairRequired: vehicleFormik.values.repairType,
      };
      dispatch(updateLocalVehicleDetails(myVehicle));
    }
  }, [vehicleFormik.values.repairType]);


  useEffect(() => {
    setValidToGo(vehicleFormik.isValid)
  }, [vehicleFormik.isValid]);

  //------------------------------------
  //return plate number UI for Ar and En
  const getPlate = (e) => {
    return isArabic(i18n.language) ? (
      <>
        <span className="numbers ar"> {ConvertToArabicNumbers(vehicle.plateNumber)} </span>
        <span className="chars ar">
          {" "}
          {vehicle.plateTextRight} {vehicle.plateTextMiddle} {vehicle.plateTextLeft}{" "}
        </span>
      </>
    ) : (
      <>
        <span className="numbers en">{vehicle.plateNumber} </span>
        <span className="chars en">
          {ConvertToEnglishLetters(
            vehicle.plateTextRight + "" + vehicle.plateTextMiddle + "" + vehicle.plateTextLeft
          )}
        </span>
      </>
    );
  };

  const getName = (driver) => {
    return isArabic(i18n.language)
      ? `${driver?.araFirstName} ${driver?.araLastName}`
      : `${driver?.engFirstName} ${driver?.engLastName}`;
  };
  const getYearOfBirth = (date) => {
    const dateParts = date.split("-");
    const dateObject = new Date(`${dateParts[2]}-${dateParts[1]}-${dateParts[0]}`);
    const year = dateObject.getFullYear();
    return year;
  };



// ----------------------------------------------------------------------------
// Add Driver

  const driverFormik = useFormik({
    initialValues: {
      nationalId: "",
      yob: null,
      vehicle: vehicle.chassisNumber,
    },
    validate: (data) => {
      let errors = {};

      if (!data.nationalId) {
        errors.nationalId = t("TP-claim.home-nationalId");
      } else if (!isValidSaudiIDOrIQama(data.nationalId)) {
        errors.nationalId = t("TP-claim.home-nationalId-valid");
      }

      if (!data.yob) {
        errors.yob = t("TP-claim.home-yob");
      }
      return errors;
    },

    onSubmit: (data) => {
      dispatch(updateLoading(true));
      getDriverDetailsPolicy(data, businessLine)
        .then((response) => {
          if (response && response.resultCode && response.resultCode === "V") {
            toast.current.show({
              severity: "error",
              summary: "Error",
              detail: response.resultMessage,
              life: 6000,
            });
          } else {
            dispatch(
              updateLocalDriver({
                ...data,
                ...response,
                vehicle: vehicle.chassisNumber,
              })
            );
            driverFormik.setFieldValue("nationalId", "");
            driverFormik.setFieldValue("yob", "");
            setShowAddDriver(false);
            triggerGetProposal();
          }
        })
        .catch((e) => {})
        .finally((e) => {
          dispatch(updateLoading(false));
        });
    },
  });

  const handleDriverRemove = (driver) => {
    let DRIVERS = [...drivers];
    DRIVERS = DRIVERS.filter((d) => d.IDNO !== driver.IDNO);
    dispatch(removeDriver(driver));
    triggerGetProposal();
  };

  useEffect(() => {
    const yobList = isSaudi(driverFormik.values.nationalId)
      ? getHijriYearOfBirthList()
      : getGregYearOfBirthList();
    setYearOfBirthList(yobList);
  }, [driverFormik.values.nationalId]);
// ----------------------------------------------------------------------------


const getFormErrorText = (tempFormik, name) => {
  return isFormFieldValid(vehicleFormik, name)? tempFormik.errors[name] : "";
};

const deductibleOptionTemplate = (option) => {
  return (
      <div className="flex align-items-center">
         <div>{option.deductible} {t('Motor.covers_up_to')} {option.coverage} </div>
      </div>
  );
};

  return (
    <StyleWrapper className={`preview_wrapper${i18n.language ==='ar' ? " ar" : ""}`}>
      <Toast ref={toast} />
      {/* <div className="set-accord">
        <div className="reuse-accord">
        </div>
      </div> */}
      <Accordion
        activeIndex={0}
        onTabOpen={() => handleAccordion(true)}
        onTabClose={() => handleAccordion(false)}
      >
        <AccordionTab
          header={
            <div className="flex-container p-2 w-100">
              <React.Fragment>
                <div className="header_flex">
                  <div className="check_wrapper">
                    <Checkbox
                      checked={selectedItems.includes(vehicle.chassisNumber)}
                      onChange={() => handleCheckboxChange(vehicle.chassisNumber)}
                    />
                  </div>
                  <div className="car_text">
                    <div className="make_model mb-1">
                      <span className="make">{vehicle.makeName} </span>- {vehicle.modelName}
                    </div>
                    <div className="plate">{getPlate()}</div>
                  </div>
                  <div className="driver_label">
                    <span>{drivers.length}</span> <span> {t("Driver")}</span>
                  </div>
                  <div className="Icon-Div">{accordion ? <UPArrow /> : <DownArrow />}</div>
                </div>
              </React.Fragment>
            </div>
          }
        >
          <div className="inner_content">
            <div className="row w-100">
              <div className="col-md-12 mb-3">
                <div className="field">
                  <span
                    className={classNames({
                      "p-float-label": true,
                      "p-invalid": Boolean(getFormErrorMessage(vehicleFormik, "model")),
                    })}
                  >
                    <Dropdown
                      value={vehicleFormik.values.model}
                      name="model"
                      onChange={vehicleFormik.handleChange}
                      options={models}
                      optionLabel="description"
                      filter
                      filterBy="description"
                      disabled={vehicle.modelCode}
                    />
                    {!vehicle.modelCode && <label htmlFor="dd-city">{t("SelectModel")}</label>}
                  </span>
                  <small className="p-error block">
                    {getFormErrorMessage(vehicleFormik, "model")}
                  </small>
                </div>
              </div>

              {formik.values.proposalCode === "PRMotorImtiazeCO" && (
                <>
                  <div className="col-md-12 mb-3">
                    <div className="field">
                      <span
                        className={classNames({
                          "p-float-label": true,
                          "p-invalid": Boolean(getFormErrorMessage(vehicleFormik, "deductible")),
                        })}
                      >
                        <Dropdown
                          name="deductible"
                          value={vehicleFormik.values.deductible}
                          onChange={vehicleFormik.handleChange}
                          options={config.deductible}
                          optionLabel="label"
                        />
                        <label htmlFor="dd-city">{t("MotorEn.Deductible")}</label>
                      </span>
                      <small className="p-error block">
                        {getFormErrorMessage(vehicleFormik, "deductible")}
                      </small>
                    </div>
                  </div>
                  <div className="col-md-12 mb-3">
                    <div className="field">
                      <span
                        className={classNames({
                          "p-float-label": true,
                          "p-invalid": Boolean(getFormErrorMessage(vehicleFormik, "repairType")),
                        })}
                      >
                        <Dropdown
                          inputId="repairType"
                          name="repairType"
                          value={vehicleFormik.values.repairType}
                          options={repairTypeList}
                          onChange={vehicleFormik.handleChange}
                          optionLabel={i18n.language === "en" ? "nameEn" : "nameAr"}
                        />
                        <label htmlFor="dd-city">{t("POLICY.REPAIR_TYPE")}</label>
                      </span>
                      {getFormErrorMessage(vehicleFormik, "repairType")}
                    </div>
                  </div>
                  {/* <div className="col-md-12 mb-3">
                    <div className="field">
                      <span
                        className={classNames({
                          "p-float-label": true,
                          "p-invalid": Boolean(getFormErrorMessage(vehicleFormik, "repairType")),
                        })}
                      >
                        <InputNumber
                           name="vehicleValue"
                           value={vehicleFormik.values.vehicleValue}
                           onChange={vehicleFormik.handleChange}
                        />
                        <label htmlFor="Vehicle Value">{t("MotorEn.VehicleValue")}</label>
                      </span>
                      {getFormErrorMessage(vehicleFormik, "vehicleValue")}
                    </div>
                  </div> */}
                  <div className="col-md-12 mb-3">
                    <LeadInput
                      name="vehicleValue"
                      value={vehicleFormik.values.vehicleValue}
                      onChange={vehicleFormik.handleChange}
                      label={i18n.t("MotorEn.VehicleValue")}
                      error={getFormErrorText(vehicleFormik, "vehicleValue")}
                      number={true}
                    />
                  </div>
                </>
              )}

              {formik.values.proposalCode === "PRMotorImtiazeSP" && (
                <>
                  <div className="col-md-12 mb-3">
                    <div className="field">
                      <span
                        className={classNames({
                          "p-float-label": true,
                          "p-invalid": Boolean(getFormErrorMessage(vehicleFormik, "deductibleSP")),
                        })}
                      >
                        <Dropdown
                          name="deductibleSP"
                          value={vehicleFormik.values.deductibleSP}
                          onChange={vehicleFormik.handleChange}
                          options={defaultValues?.spDeductibleList}
                          optionLabel="deductible"
                          optionValue="deductible"
                          itemTemplate={deductibleOptionTemplate}
                        />
                        <label htmlFor="dd-city">{t("MotorEn.Deductible")}</label>
                      </span>
                      <small className="p-error block">
                        {getFormErrorMessage(vehicleFormik, "deductibleSP")}
                      </small>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>

          <h4>{t("MotorEn.Drivers")}</h4>
          {drivers?.map((driver, index) => {
            if (index === 0) {
              return (
                <div key={"driver" + index} className="driver_list">
                  <div className="icon_wrapper">
                    {driver.genderCode == "F" ? <FemaleIco /> : <MaleIco />}
                  </div>
                  <div className="details_wrapper">
                    <div className="name">{getName(driver)}</div>
                    <div className="details">
                      <span>
                        {t("ID")}: {driver.IDNO}
                      </span>{" "}
                      <span>
                        {t("BirthYear")}: {getYearOfBirth(driver.gregDob)}
                      </span>
                    </div>
                  </div>
                  <div className="badge">{t("Owner")}</div>
                </div>
              );
            }
            if (driver.vehicle === vehicle.chassisNumber) {
              return (
                <div key={"driver" + index} className="driver_list">
                  <div className="icon_wrapper">
                    {driver.genderCode == "F" ? <FemaleIco /> : <MaleIco />}
                  </div>
                  <div className="details_wrapper">
                    <div className="name">{getName(driver)}</div>
                    <div className="details">
                      <span>
                        {t("ID")}: {driver.IDNO}
                      </span>{" "}
                      <span>
                        {t("BirthYear")}: {getYearOfBirth(driver.gregDob)}
                      </span>
                    </div>
                  </div>
                  <div className="badge">{t("Driver")}</div>
                  <div className="remove" onClick={() => handleDriverRemove(driver)}>
                    <TrashIco />
                  </div>
                </div>
              );
            } else {
              return "";
            }
          })}

          <Divider />

          <div className="row">
            <div className="col-12">
              {drivers.length < 4 && !showAddDriver && (
                <button className="add-driver-btn" onClick={(e) => setShowAddDriver(true)}>
                  <AddIco />
                  {t("Motor.AddAnotherDriver")}
                </button>
              )}
            </div>
          </div>
          {showAddDriver && drivers.length < 4 && (
            <div className="driver-card form_card">
              <header className="mb-2">
                <p>{t("AdditionalDriverInformation")}</p>
              </header>

              <form onSubmit={driverFormik.handleSubmit} className="row">
                <div className="field w-100 mb-3">
                  <LeadInput
                    maxLength={10}
                    name="nationalId"
                    value={driverFormik.values.nationalId}
                    onChange={driverFormik.handleChange}
                    className={classNames({
                      "p-invalid": isFormFieldValid(driverFormik, "nationalId"),
                    })}
                    label={t("PERSONAL_DETAIL.NATIONAL_ID")}
                    error={getFormErrorMessage("nationalId")}
                  />
                </div>

                <div className="field w-100 mb-3">
                  <span className="p-float-label">
                    <Dropdown
                      name="yob"
                      className={classNames({ "p-invalid": isFormFieldValid(driverFormik, "yob") })}
                      value={driverFormik.values.yob}
                      onChange={driverFormik.handleChange}
                      options={yearOfBirthList}
                      optionLabel="label"
                      optionValue="value"
                      filter
                      filterBy="label"
                      showFilterClear={true}
                    />
                    <label htmlFor="yob">{t("PERSONAL_DETAIL.YEAROFBIRTH")}</label>
                  </span>
                  {getFormErrorMessage("yob")}
                </div>
              </form>

              <div className="actions">
                <Button type="submit" className="save-b" onClick={() => driverFormik.submitForm()}>
                  {t("Load driver’s details")}
                </Button>
                <Button
                  onClick={() => {
                    setShowAddDriver(false);
                    driverFormik.resetForm();
                  }}
                  className="close-b"
                >
                  {t("MotorEn.Close")}
                </Button>
              </div>
            </div>
          )}
        </AccordionTab>
      </Accordion>
    </StyleWrapper>
  );
};

export default VehicleCard;
